import pluralize from 'pluralize'
import {
  MonitorParseError,
  MonitorParseManualPassageDataResponseErrors,
} from '~/api/backend/pages/wellPageAPI'
import { components } from '~/api/desktop/generated-schema'
import { displayCount } from '~/utils/string'
import { ErrorGroup } from '../../utils/GroupedErrorTable'
import { generateErrorGroups } from '../../utils/generateErrorGroups'

export type RecordManualPassageParseDataError =
  | components['schemas']['ParseCultureDataEmptyWell']
  | MonitorParseError

const _getErrorTypeForError = (
  error: RecordManualPassageParseDataError,
): RecordManualPassageParseDataError['type'] => {
  return error.type
}

const _getGroupHeaderForErrorType = (
  errorType: RecordManualPassageParseDataError['type'],
  numErrors: number,
): string => {
  if (errorType === 'empty_well') {
    return `${displayCount('well', numErrors)} ${pluralize(
      'has',
      numErrors,
    )} never contained a live culture.`
  } else if (errorType === 'plate_not_found') {
    return `${displayCount('plate', numErrors)} could not be found.`
  } else if (errorType === 'well_not_found') {
    return `${displayCount('well', numErrors)} could not be found.`
  }

  return `${displayCount('error', numErrors)} found.`
}
const _getErrorDisplayElement = (
  error: RecordManualPassageParseDataError,
): React.ReactNode => {
  if (error.type === 'empty_well') {
    const emptyWellError = error as components['schemas']['ParseCultureDataEmptyWell']
    return (
      <span>
        <b>{emptyWellError.well}</b> in plate <b>{emptyWellError.plate_barcode}</b> has
        never contained a live culture. <i>(Row {error.line_number})</i>
      </span>
    )
  } else if (error.type === 'plate_not_found') {
    const parseError = error as MonitorParseError
    return <span>{parseError.message}</span>
  } else if (error.type === 'well_not_found') {
    const parseError = error as MonitorParseError
    return <span>{parseError.message}</span>
  }

  const parseError = error as MonitorParseError
  return <span>{parseError.message || 'Unknown error'}</span>
}

export const getRecordManualPassageParseDataErrorGroups = (
  errors: MonitorParseManualPassageDataResponseErrors,
): ErrorGroup[] => {
  return generateErrorGroups<
    RecordManualPassageParseDataError,
    RecordManualPassageParseDataError['type']
  >(
    errors.errors,
    _getErrorTypeForError,
    _getGroupHeaderForErrorType,
    _getErrorDisplayElement,
  )
}
